export default function TopLevelErrorHandler(
  transactionId,
  displayError,
  logError
) {
  this.wrap = (fn) => async (...args) => {
    try {
      return await fn(...args);
    } catch (e) {
      await displayError(transactionId);
      await logError(e);
      throw e;
    }
  };

  this.invoke = function (fn) {
    this.wrap(fn)();
  };
}
